/* eslint-disable consistent-default-export-name/default-export-match-filename */
// eslint-disable-next-line import/default
import React from 'react'
import User from './User.js'
import { Header as OriginalHeader } from '@betterplace/design-system/page-parts'

/**
 * @typedef {import('react').ComponentProps<typeof OriginalHeader>} HeaderProps
 */
/**
 * @typedef {Omit<HeaderProps, 'children'> & {user: {loginInfoUrl: string, loginUrl: string, label: string, myProfile: string}}} HeaderPropsWithUser
 */

/**
 * @param {HeaderPropsWithUser} props
 * @returns {React.ReactElement}
 */
function HeaderWithChildren({ user, ...props }) {
  return React.createElement(OriginalHeader, props, React.createElement(User, user))
}

/**
 * @type {HeaderPropsWithUser}
 */
HeaderWithChildren.railsProps = {
  text: {
    links: [
      {
        href: `<%= categories_url %>`,
        external: false,
        hidden: false,
        children: `<%= t('.discover') %>`,
      },
      {
        href: `<%= landingpage_url(Landingpage::CollectDonations) %>`,
        external: false,
        hidden: false,
        children: `<%= t('.get_started_label') %>`,
      },
      {
        href: `<%= t('external_urls.about_us_path') %>`,
        external: false,
        hidden: false,
        children: `<%= t('.about_us') %>`,
      },
    ],
    homePageUrl: `<%= root_url %>`,
    logoAlt: `<%= t('.logo_alt_text') %>`,
    searchLabel: `<%= t('verbs.search') %>`,
    searchPlaceholder: `<%= t('layouts.header.search_placeholder') %>`,
    searchUrl: `<%= homepage_search_url %>`,
    claim: `<%= t('.claim') %>`,
  },
  user: {
    loginInfoUrl: `<%= login_check_layouts_url %>`,
    loginUrl: `<%= header_login_url %>`,
    label: `<%= t('layouts.header.login') %>`,
    myProfile: `<%= t('layouts.header.my_profile') %>`,
  },
}
HeaderWithChildren.railsTemplateFile = 'views/layouts/_header.html.erb'
export const Header = OriginalHeader
export default HeaderWithChildren
